<template>
  <div>
    <span v-if="loteOficial" class="size-status" style="color: purple">
      <v-icon small color="purple" class="icon-status pb-1">mdi-star</v-icon>
      Oficial
    </span>
    <span v-else class="size-status" style="color: gray">
      <v-icon small color="gray" class="icon-status pb-1">mdi-star-off</v-icon>
      Comum
    </span>
  </div>
</template>

<script>
  export default {
    name: 'LoteOficial',
    props: {
      loteOficial: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
